import ScheduledTaskExtraTaskCols from './ScheduledTaskExtraTaskCols';
import { extractBedParts } from '../../../../../../../utility';

const ScheduledTaskRow = ({ item, assignmentId, getScheduledTasks, handleGetAssignment }) => {
  if (!item) return;

  const targetType = item.bed ? 'bed' : 'resident';
  return (
    <>
      <tr>
        <td className="resident-col" rowSpan={item.tasks?.length}>
          {item.resident ? item.resident.full_name : ''}
        </td>
        <td className="bed-col" rowSpan={item.tasks.length}>
          {item.bed ? (
            <>
              <strong>{extractBedParts(item.bed.bed).number}</strong> {extractBedParts(item.bed.bed).letter}
            </>
          ) : (
            ''
          )}
        </td>
        {item.tasks.length ? (
          <ScheduledTaskExtraTaskCols
            task={item.tasks[0]}
            index={0}
            targetType={targetType}
            assignmentId={assignmentId}
            getScheduledTasks={getScheduledTasks}
            handleGetAssignment={handleGetAssignment}
          />
        ) : (
          <></>
        )}
      </tr>
      {item.tasks?.slice(1)?.map((task, index) => (
        <tr className="extra-task-row" key={index}>
          <ScheduledTaskExtraTaskCols
            task={task}
            index={index + 1}
            targetType={targetType}
            assignmentId={assignmentId}
            getScheduledTasks={getScheduledTasks}
            handleGetAssignment={handleGetAssignment}
          />
        </tr>
      ))}
    </>
  );
};

export default ScheduledTaskRow;
